import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import BlogCard from './BlogCard';
import blogImg1 from '../../assets/img/blog1.jpg'
import blogImg2 from '../../assets/img/blog2.jpg'
import blogImg3 from '../../assets/img/blog3.jpg'
import blogImg4 from '../../assets/img/blog4.jpg'
import blogImg5 from '../../assets/img/blog5.jpg'
import blogImg6 from '../../assets/img/blog6.jpg'
import blogImg7 from '../../assets/img/blog7.jpg'

import BlogsContent from './BlogsContent';
import '../../App.css'

function Blogs() {
  return (
          <div className="container-fluid">

    <div className='container'>
            <Fade>

            <Heading className='text-center'>Latest Blog</Heading>
            </Fade>
        <Container>

            {/* Row */}
            <Fade up>
        <BlogCard 
                image = {blogImg1}
                title = { <>A GUIDE TO CREATING AN EFFECTIVE IDEA AND BUSINESS PLAN</>}
                date='February 9, 2022'
                blogID='A-GUIDE-TO-CREATING-AN-EFFECTIVE-IDEA-AND-BUSINESS-PLAN'/>
        <BlogCard 
                image={blogImg2}
                title = 'HOW TO START A BUSINESS WITH LOW INVESTMENT?'
                date='February 6, 2022'
                blogID='HOW-TO-START-A-BUSINESS-WITH-LOW-INVESTMENT'/>
        <BlogCard 
                image ={blogImg3}
                title = {<>WHY ARE AUDIENCE GETTING ADDICTED TO LACUNA MART<span id='more-dot'>...</span> <span id='hover-to-show'>NOWADAYS?</span></>}
                date='October 14, 2021'
                blogID='WHY-ARE-AUDIENCE-GETTING-ADDICTED-TO-LACUNA-MART-NOWADAYS'/>
            </Fade>

            {/* Row */}

            {/* Row */}
            <Fade up>


        <BlogCard 
                image ={blogImg4} 
                title = {<>THE COMPLETE BEGINNERS GUIDE TO ENTREPRENEURS- STARTUP <span id='more-dot'>...</span> <span id='hover-to-show'> GUIDES FOR ENTREPRENEURS </span></>}
                date='June 27, 2021'
                blogID='THE-COMPLETE-BEGINNERS-GUIDE-TO-ENTREPRENEURS-STARTUP-GUIDES-FOR-ENTREPRENEURS'/>

            </Fade>
            {/* Row */}

                 {/* Row */}
    
            <Fade up>

        <BlogCard 
                image = {blogImg5}
                title = 'WHERE DOES NEPAL STAND ON INNOVATIVE STARTUPS?'
                blogID='WHERE-DOES-NEPAL-STAND-ON-INNOVATIVE-STARTUPS'/>
        <BlogCard 
                image={blogImg6}
                title = 'STARTUPS, FAILING BUSINESSES, AND THE TOUGHEST DECISIONS'
                blogID='STARTUPS-FAILING-BUSINESSES-AND-THE-TOUGHEST-DECISIONS'/>
            </Fade>
            {/* </Fade> */}

    {/* Row */}
                
                {/* Row */}
                <Fade up>

                <BlogCard 
                image = {blogImg7} 
                title = 'WHY DO STARTUPS IN NEPAL FAIL?'
                blogID='WHY-DO-STARTUPS-IN-NEPAL-FAIL'/>
                </Fade>
                {/* Row */}

        </Container>
        </div>
        
    </div>
  )
}

export default Blogs
const Container = styled.div`
text-align:center ;
font-family:Arial, Helvetica, sans-serif ;
display:grid;
grid-gap:20px;
grid-template-columns: repeat(auto-fit, minmax(300px,1fr));
margin-top:30px ;
margin-bottom:50px ;
`
const Heading = styled.h1`

    font-size:50px ;
    text-transform:uppercase ;
    font-family:Montserrat Bold;
    /* font-family:Arial, Helvetica, sans-serif ; */
    font-weight:bold;
    transition: all ease .6s ;
    color: #fa7525;
    margin-top:100px ;
    
      &:hover{
          letter-spacing:6px ;
      }
      @media (max-width:700px){
              /* text-align:center ; */
      }
`
